module.exports = __webpack_public_path__ + "static/media/token6.c826704a.png";